<div class="bg-white rounded-xl border border-gray-200 p-6 h-full shadow-[0_4px_15px_#00000008]">
  <h3 class="text-lg font-semibold text-gray-900 m-0 mb-2">Top Usage by Time</h3>
  <div class="relative w-full min-h-[450px] flex items-center justify-center">
    <canvas #topUsageCanvas [ngClass]="{'hidden': loading }"></canvas>
    <div *ngIf="loading" class="absolute inset-0">
      <ngx-skeleton-loader [theme]="{ 'border-radius': '8px', height: '450px', width: '100%' }">
      </ngx-skeleton-loader>
    </div>
  </div>
</div>